import { schema } from 'normalizr';

const getAccountGOS = new schema.Entity('accountGOS');

export default getAccountGOS;
